import { WBDesignSystemProvider } from "@apptractive/design-system-web";
import awsmobile from "./aws-exports";
import { LinkBehavior } from "./components/common/link-behaviour";
import { SubscriptionsHoc } from "./components/SubscriptionsHoc";
import { NavRoutes } from "./navigation/NavRoutes";
import { darkTheme, theme } from "@apptractive/stm-shared";
import { Amplify } from "aws-amplify";
import "./i18n";

Amplify.configure(awsmobile);

const commonTheme = {
  MuiLink: {
    ...theme.components,
    //defaultProps: {
    //  component: LinkBehavior
    //}
  },
  MuiButtonBase: {
    defaultProps: {
      LinkComponent: LinkBehavior,
    },
  },
};

const reactTheme = {
  ...theme,
  components: {
    ...theme.components,
    ...commonTheme,
  },
};

const reactDarkTheme = {
  ...darkTheme,
  components: {
    ...theme.components,
    ...commonTheme,
  },
};

function App() {
  return (
    <WBDesignSystemProvider theme={reactTheme} darkTheme={reactDarkTheme}>
      <SubscriptionsHoc />
      <NavRoutes />
    </WBDesignSystemProvider>
  );
}

export default App;
